import { render, staticRenderFns } from "./LogoutWarningModal.vue?vue&type=template&id=40cca78a&scoped=true&"
import script from "./LogoutWarningModal.vue?vue&type=script&lang=js&"
export * from "./LogoutWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./LogoutWarningModal.vue?vue&type=style&index=0&id=40cca78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cca78a",
  null
  
)

export default component.exports